export default __webpack_public_path__ + "static/IBMPlexSans-Bold-Cyrillic-9f53518bc14134a85f1fb6db4afcc32e.woff";